import { render, staticRenderFns } from "./VisDiagram.vue?vue&type=template&id=0c8b7543&"
import script from "./VisDiagram.vue?vue&type=script&lang=js&"
export * from "./VisDiagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c8b7543')) {
      api.createRecord('0c8b7543', component.options)
    } else {
      api.reload('0c8b7543', component.options)
    }
    module.hot.accept("./VisDiagram.vue?vue&type=template&id=0c8b7543&", function () {
      api.rerender('0c8b7543', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VisDiagram.vue"
export default component.exports